<template>
  <div class="unit-test">
    <div class="controls">
      <textbook-category-select
        :key="courseTypeCode + '-' + categoryCode + '-' + textbookVersion"
        :course-type-code="courseTypeCode"
        :category-code="categoryCode"
        :version="textbookVersion"
        @change="selectLevels"
      />

      <el-form
        ref="form"
        class="select-unit"
        label-width="80px"
      >
        <el-form-item
          ref="unitSelectForm"
          label="单元"
        >
          <el-cascader
            v-model="levelAndUnit"
            style="min-width: 620px"
            filterable
            :props="levelsSelectionProps"
            :options="levels"
            @change="selectTextbook"
          >
            <template slot-scope="{ node, data }">
              <span style="float: left">{{ data.name }}</span>
              <span
                v-if="data.isUsed === 0"
                style="float: right; color: #8492a6; font-size: 13p"
              >{{ $t("禁用") }}</span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="试卷标准">
          <el-select
            v-model="standard"
            filterable
            @change="search"
          >
            <el-option
              v-for="item in standards"
              :key="item.type"
              :label="item.label"
              :value="item.type"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div class="add">
        <el-button
          v-if="$hasPermission('unitTestCreate')"
          icon="el-icon-plus"
          size="small"
          :disabled="!$route.query.unitId"
          @click="
            $router.push({
              name: 'unitTestAdd',
              params: { unitId: $route.query.unitId},
              query: { standard }
            })
          "
        >
          新增试卷
        </el-button>
      </div>
    </div>

    <el-table
      :data="unitTestVersions"
      style="width: 100%"
    >
      <el-table-column
        fixed
        label="online"
        width="70"
      >
        <template slot-scope="scope">
          <div
            :class="{ online: scope.row.online, offline: !scope.row.online }"
          />
        </template>
      </el-table-column>
      <el-table-column
        fixed
        prop="version"
        label="版本号"
        width="80"
      />
      <el-table-column
        label="支持设备"
        width="100"
      >
        <template slot-scope="scope">
          <i
            v-for="device of scope.row.devices"
            :key="device"
            class="iconfont"
            :class="{
              'icon-iphone': device === 'mobile',
              'icon-ipad': device === 'pad',
              'icon-pc': device === 'pc'
            }"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="试卷名"
        width="200"
      />
      <el-table-column
        prop="describe"
        width="300"
        label="试卷描述"
      />

      <el-table-column
        label="状态"
        width="100"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.checkingStatus === 'rejected' &&
                !!scope.row.checkingMessage
            "
            class="item"
            effect="dark"
            :content="scope.row.checkingMessage"
            placement="top"
          >
            <span>{{ scope.row.checkingStatus || "-" | checkStatus }}</span>
          </el-tooltip>
          <span v-else>{{
            scope.row.checkingStatus || "-" | checkStatus
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布人"
        width="110"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedBy || "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="发布时间"
        width="180"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.publishedAt | dateFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="180"
      >
        <template slot-scope="scope">
          <div class="operate">
            <!-- 审核中和审核后不能编辑 -->
            <el-button
              v-if="
                $hasPermission('unitTestEdit') &&
                  (scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved')
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'unitTestEdit',
                  params: { unitId: $route.query.unitId },
                  query: { version: scope.row.version, standard }
                })
              "
            >
              {{ $t("编辑") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('unitTestDelete') &&
                  (scope.row.checkingStatus !== 'waiting' &&
                  scope.row.checkingStatus !== 'resolved')
              "
              size="small"
              type="text"
              @click="deleteVersion(scope.row.version)"
            >
              {{ $t("删除") }}
            </el-button>

            <el-dropdown
              trigger="hover"
              @command="preview"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("预览") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{'version': scope.row.version,'device': 'mobile','metalang':'zh-CN'}">
                  <el-button
                    size="small"
                    type="text"
                  >
                    国内
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'device': 'mobile','metalang':item.value}"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="
                $hasPermission('unitTestCheck') &&
                  scope.row.checkingStatus === 'waiting'
              "
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'unitTestCheck',
                  params: { unitId: $route.query.unitId },
                  query: { version: scope.row.version, standard }
                })
              "
            >
              {{ $t("审校") }}
            </el-button>

            <el-button
              v-if="
                $hasPermission('unitTestPublish') &&
                  scope.row.checkingStatus === 'resolved' &&
                  !scope.row.online
              "
              size="small"
              type="text"
              @click="publish(scope.row.version)"
            >
              {{ $t("发布") }}
            </el-button>

            <el-dropdown
              trigger="hover"
              @command="rePublish"
            >
              <el-button
                size="small"
                type="text"
              >
                {{ $t("重新发布") }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item,key) in languages"
                  :key="key"
                  :command="{'version': scope.row.version,'metalang': item.value}"
                  class="iconfont"
                >
                  <el-button
                    size="small"
                    type="text"
                  >
                    {{ item.name }}
                  </el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-button
              v-if="
                $hasPermission('unitTestCreate') &&
                  scope.row.checkingStatus === 'resolved'
              "
              size="small"
              type="text"
              @click="fork(scope.row.version)"
            >
              {{ $t("复制") }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="forkDialogVisible">
      <fork-unit-test
        v-if="forkUnitTestVersion"
        :id="$route.query.unitId"
        :key="($route.query.unitId || '') + '-' + forkUnitTestVersion"
        type="ut"
        :standard="standard"
        :version="forkUnitTestVersion"
        @close="forkClose"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="previewdialogVisible"
      width="240px"
      @close="closePreviewDialog"
    >
      <qrcode
        v-if="currentPreviewUrl"
        :text="currentPreviewUrl"
        :show-text="true"
      />
    </el-dialog>
  </div>
</template>
<style lang="less" scoped>
.controls {
  position: relative;
  .add {
    position: absolute;
    right: 30px;
    bottom: 0;
  }
}

.operate {
  .el-button {
    margin-right: 10px;
  }
}

.offline,
.online {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: #8bc34a 1px solid;
}

.online {
  background-color: #8bc34a;
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:unit-test');
import axios from 'axios';
import { find } from 'lodash';
import { noopPromise } from '../utils';
import qrcode from '../components/qrcode';
import forkUnitTest from '../components/fork';
import textbookCategorySelect from '../components/textbook_category_select';
import {
	getTextbook,
	getTextbookChildren,
	getTextbookParent,
	getTextbookSeries,
	getTextbookCategoryTree
} from '../service/textbook';
import { PAPER_STANDARD } from '../constants';

export default {
	components: {
		forkUnitTest,
		textbookCategorySelect,
		qrcode
	},
	data() {
		return {
			levelsSelectionProps: {
				lazy: true,
				value: 'id',
				label: 'name',
				expandTrigger: 'hover',
				lazyLoad(node, resolve) {
					if (node.value) {
						const levelId = node.value;
						getTextbookChildren({ textbookId: levelId }).then(units => {
							units.forEach(unit => {
								// 没有子节点
								unit.leaf = true;
							});

							resolve(units);
						});
					} else {
						resolve();
					}
				}
			},

			forkDialogVisible: false,
			forkUnitTestVersion: null,

			// 教材分类
			levels: [],
			courseTypeCode: '',
			categoryCode: '',
			textbookVersion: '',
			levelAndUnit: [],
			unitId: null,

			// 试卷版本信息
			unitTestVersions: [],
      
			// 试卷标准
			standard: '2',
			standards: PAPER_STANDARD,
			currentPreviewUrl: '',
			previewdialogVisible: false,
			languages: []
		};
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		'$route.query.unitId': async function(curr, prev) {
			await this.search();
			// if (curr !== prev) {
			//   await this.init();
			// } else {
			//   await this.search();
			// }
		}
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug('[init]');
			const { unitId } = this.$route.query;
			if (unitId) {
				const [level, unit] = await Promise.all([
					getTextbookParent({ textbookId: unitId }),
					getTextbook({ textbookId: unitId })
				]);

				debug(
					'[init] levelId: %s, unitId: %s, courseTypeCode: %s, categoryCode: %s, textbookVersion: %s',
					level.id,
					unit.id,
					level.courseTypeCode,
					level.categoryCode,
					level.version
				);

				this.courseTypeCode = level.courseTypeCode;
				this.categoryCode = level.categoryCode;
				this.textbookVersion = level.version;
				this.levelAndUnit = [level.id, unit.id];
			}
			this.languages = await axios.get('/api/languages');
			await this.search();
		},

		// 单元测试题所有版本
		async search() {
			const { unitId } = this.$route.query;

			if (unitId) {
				const unitTestVersions = await axios.get(`/api/ut/${unitId}/versions`, {
					params: { standard: this.standard }
				});
				debug('[search] unitTestVersions: %o', unitTestVersions);
				this.unitTestVersions = unitTestVersions;
			}
		},

		async selectLevels(levels) {
			debug('[selectLevels]', levels);
			this.levels = levels;
			this.$nextTick(() => {
				this.triggerCascaderValue();
			});
		},

		selectTextbook() {
			const [_, unitId] = this.levelAndUnit;
			this.$router.replace({ query: { unitId } });
		},

		async deleteVersion(version) {
			const { unitId } = this.$route.query;
			if (!unitId) return;

			await axios.delete(`/api/ut/${unitId}/${version}?standard=${this.standard}`);
			await this.search();
		},

		async preview(val) {
			const { unitId } = this.$route.query;
			if (!unitId) return;

			const { version, device ,metalang} = val;

			/* eslint no-undef:0 */
			debug('[preview] version: %s', version);
			// const unitTestVersion = find(this.unitTestVersions, { version });unitTestVersion)
			// if (!unitTestVersion.httpUrl) unitTestVersion.httpUrl = {};
			// if (unitTestVersion.httpUrl[device]) return;

			const urls = await axios.get(`/api/ut/${unitId}/urls`, {
				params: { version, standard: this.standard }
			});
			let previewUrl = urls.mobile.split('?') ? urls[device].split('?')[0] : '';
			previewUrl = `${previewUrl}?preview=true&metalang=${metalang}`;
			// 替换域名，因为 itextbook.51talk.com 的 cdn 缓存会造成缓存了预览题型的数据
			previewUrl = previewUrl.replace(/^http:\/\/[^/]+/, 'http://api.ccs.51talkjr.com');
			this.currentPreviewUrl = previewUrl;
			this.previewdialogVisible = true;
			// this.$set(unitTestVersion, 'httpUrl', previewUrl);
		},
		// 关闭预览dialog时清除数据
		closePreviewDialog() {
			this.currentPreviewUrl = '';
		},

		// 题发布
		async publish(version) {
			const { unitId } = this.$route.query;
			if (!unitId) return;

			await axios.post(`/api/ut/${unitId}/publish`, { version, standard: this.standard });
			await this.search();
		},

		async rePublish(val){
			const { unitId } = this.$route.query;
			if (!unitId) return;
			const { version, metalang } = val;
			const data = await axios.get('api/paper/metalang/publish', {
				params: { version:version,metalang:metalang,businessid:unitId,category:'ut',standard: this.standard },
			});
			if(data.code == 1){
				alert('success');
			}else{
				alert(data.msg);
			}
		},

		async fork(version) {
			this.forkDialogVisible = true;
			this.forkUnitTestVersion = version;
			debug('[fork] version: %s', version);
		},

		async forkClose(unitId) {
			this.forkDialogVisible = false;
			this.forkUnitTestVersion = null;
			if (!unitId) return; // 取消

			if (this.$route.query.unitId !== unitId) {
				this.$router.push({ query: { unitId } });
				window.location.reload();
			} else {
				await this.search();
			}
		},

		async triggerCascaderValue() {
			const { unitId } = this.$route.query;
			if (!unitId) return;

			debug('[triggerCascaderValue] unitId: %o', unitId);
			try {
				const el = this.$refs.unitSelectForm.$el.querySelector(
					'.el-cascader > .el-input > input'
				);
				if (el.value) return;

				const [level, unit] = await Promise.all([
					getTextbookParent({ textbookId: unitId }),
					getTextbook({ textbookId: unitId })
				]);

				debug(
					'[triggerCascaderValue] name: %s',
					unit.name + ' / ' + level.name
				);
				el.value = unit.name + ' / ' + level.name;
			} catch (ignored) {}
		},
		change() {
			console.log(this.standard); //eslint-disable-line
		}
	}
};
</script>
